import { useQuery } from "@apollo/client";
import { GET_TRIP } from "../graphQl/TripPublicationAPI";

const withAuthorization = (accessToken) => ({
  headers: {
    authorization: accessToken ? `Bearer ${accessToken}` : "",
  },
});

const normalizeTripProgramDetail = (detail) => ({
  ...detail,
  activities: detail?.activities || [],
});

const normalizeTrip = (trip) => {
  if (!trip) {
    return null;
  }

  return {
    ...trip,
    tripProgramDetails: (trip.tripProgramDetails || []).map(normalizeTripProgramDetail),
  };
};

export const useTrip = ({ tripId = null, accessToken = "" }) => {
  const tripQuery = useQuery(GET_TRIP, {
    variables: { tripId },
    context: withAuthorization(accessToken),
    skip: !tripId,
    fetchPolicy: "network-only",
  });

  return {
    trip: normalizeTrip(tripQuery.data?.QR_GET_TRIP?.data),
    loading: tripQuery.loading,
    error: tripQuery.error,
    refetchTrip: tripQuery.refetch,
  };
};
